module.exports = __webpack_public_path__ + "static/media/gravewalkers-blue.44b29e4f.png";